export default "__VITE_ASSET__CPHIPpuG__"